import type { WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'

import { useSnackbar } from 'notistack'
import React from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import type { DialogProps } from '@paintscout/ui/components/Dialog'
import Dialog, { DialogTitle, DialogContent, DialogActions } from '@paintscout/ui/components/Dialog'
import Button from '@paintscout/ui/components/Button'
import Grid from '@paintscout/ui/components/Grid'
import InputField from '@paintscout/ui/components/InputField'

export interface ExportJsonDialogProps extends Omit<DialogProps, 'classes'>, WithStyles<typeof styles> {
  item: any
  onConfirm?: () => void
}

const styles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  input: { width: '100%', height: '100%' },
  content: { maxHeight: '100%' }
})

function ExportJsonDialog({ classes, item, onConfirm, ...otherProps }: ExportJsonDialogProps) {
  const { enqueueSnackbar } = useSnackbar()

  const sanitizedItem = { ...item }
  delete sanitizedItem.__typename

  return (
    <Dialog {...otherProps} fullScreen={true}>
      <DialogTitle>{'Export JSON'}</DialogTitle>
      <DialogContent className={classes.content}>
        <CopyToClipboard
          text={JSON.stringify(sanitizedItem, null, 2)}
          onCopy={() => enqueueSnackbar(`Copied to clipboard!`, { variant: 'success' })}
        >
          <InputField
            className={classes.input}
            multiline
            value={JSON.stringify(sanitizedItem, null, 2)}
            fullWidth={true}
          />
        </CopyToClipboard>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="center">
          <Grid item>
            <Button onClick={onConfirm} variant={'contained'}>
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles)(ExportJsonDialog)
